// extracted by css-extract-rspack-plugin
export default {"headerAction":"headerAction-Nk5fbI","headerTitle":"headerTitle-aMj9Tq","titleInfoWrapper":"titleInfoWrapper-h4RYmY","switchers":"switchers-WxJ_hv"};